import React from 'react';
import type { POStatData } from '../purchaseOrdersTypes';
import styles from './POStatCard.module.css';

interface POStatCardProps {
  stat: POStatData;
}

export const POStatCard: React.FC<POStatCardProps> = ({ stat }) => {
  return (
    <div className={`${styles.card} ${styles[stat.color]}`}>
      <div className={styles.header}>
        <span className={styles.subtitle}>{stat.subtitle}</span>
      </div>
      <p className={styles.value}>{stat.value}</p>
      <p className={styles.title}>{stat.title}</p>
    </div>
  );
};
